var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.loading ? _c("Loading") : _vm._e(),
      _c(
        "div",
        [
          _c("AppHeader"),
          _c("section", { staticClass: "disclaimer navbar-space" }, [
            _c("div", { staticClass: "container" }, [
              _c("div", { staticClass: "row justify-content-center" }, [
                _c("div", { staticClass: "col-lg-8 col-sm-12" }, [
                  _vm._m(0),
                  _c("div", { staticClass: "dis-text-box" }, [
                    _c("div", { staticClass: "accept-checkbox-wrapper" }, [
                      _c(
                        "div",
                        { staticClass: "form-check" },
                        [
                          _c(
                            "b-form-checkbox",
                            {
                              attrs: {
                                id: "acceptStatus",
                                name: "acceptStatus",
                                value: "1",
                                "unchecked-value": "0"
                              },
                              model: {
                                value: _vm.acceptStatus,
                                callback: function($$v) {
                                  _vm.acceptStatus = $$v
                                },
                                expression: "acceptStatus"
                              }
                            },
                            [
                              _vm._v(
                                "\n                    ข้าพเจ้าขอรับรองว่ารายละเอียดของคำขอเกี่ยวกับหนังสือค้ำประกันตามที่ระบุไว้ข้างต้นถูกต้อง และตรงตามความประสงค์ของข้าพเจ้าทุกประการ และให้อยู่ภายใต้ข้อกำหนดและเงื่อนไขการใช้บริการเกี่ยวกับหนังสือค้ำประกันที่ข้าพเจ้าได้ลงนามและ/หรือตกลงผูกพันไว้ก่อนหน้านี้ นอกจากนี้ หากหนังสือค้ำประกันดังกล่าวเป็นการขอให้ออกโดยให้วันที่มีผลใช้บังคับของหนังสือค้ำประกันมีผลย้อนหลัง ข้าพเจ้าขอรับรองว่า ในช่วงตั้งแต่วันที่หนังสือค้ำประกันมีผลใช้บังคับย้อนหลังจนถึงวันที่ออกหนังสือค้ำประกันตามความประสงค์ที่แจ้งไว้ ไม่มีเหตุผิดนัด/ผิดสัญญาตามสัญญาและ/หรือหนี้ที่ธนาคารค้ำประกันตามหนังสือค้ำประกันแต่อย่างใด      \n                  "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ])
                  ]),
                  _c("div", { staticClass: "row justify-content-center" }, [
                    _c(
                      "div",
                      { staticClass: "col-12 col-sm-11 col-lg-9 col-xl-9" },
                      [
                        _c("div", { staticClass: "cta-btn" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-lg btn-outline-ktb",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  return _vm.reject()
                                }
                              }
                            },
                            [_vm._v("ออกจากระบบ")]
                          ),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-lg btn-primary-ktb",
                              attrs: {
                                type: "button",
                                disabled: this.acceptStatus !== "1"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.accept()
                                }
                              }
                            },
                            [_vm._v("ตกลงและยอมรับ")]
                          )
                        ])
                      ]
                    )
                  ])
                ])
              ])
            ])
          ]),
          _c("AppFooter")
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "secondary-title" }, [
      _c("h5", { staticClass: "dis-title" }, [
        _vm._v("ข้อสงวนสิทธิ์เกี่ยวกับความรับผิดของธนาคาร")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }